// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3L6C8"};